import Vue from 'vue'
import VueRouter from 'vue-router';
import staticRoutes from './staticRoutes';
import whiteList from "./whiteList";
import store from '../store';
import {
    Loading
} from 'element-ui';

Vue.use(VueRouter);


const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
    return originalPush.call(this, location).catch(err => err)
}
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
    if (onResolve || onReject)
        return originalReplace.call(this, location, onResolve, onReject);
    return originalReplace.call(this, location).catch(err => err);
};


const router = new VueRouter({
    mode: 'hash',
    routes: staticRoutes,
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 }
    }
});

router.beforeEach((to, from, next) => {
    // 若是从welink免登跳进入系统，则清除掉本地缓存，重新登录获取用户信息
    if (to.query.origin && to.query.origin == 'wx') {
        localStorage.clear();
    }
    // 获取localstorage里的token
    let token = localStorage.getItem('token');

    // 如果为白名单，直接访问
    if (whiteList.includes(to.path)) {
        // 若已登录，用户直接通过地址栏前往登录页，则不让前往
        if (token && to.path === '/login') {
            if (!to.query._p || !to.query.ticket) return next(); // 对接苏迪免登临时逻辑
            // init(to, from, next);
            // --------跳转登录页时，清除本地缓存，前往登录页--------------
            localStorage.clear();
            return next();
        } else {
            return next();
        }
    }

    // 如果存在token，则初始化数据，
    if (token) {
        init(to, from, next);
    } else {
        // 如果用户无登录的token
        if (to.path == "/login" || to.path == "/") {
            next();
        } else {
            // 若用户在无token下想跳转到其他页面，则直接重定向至登录页
            next({
                path: '/login',
                replace: true
            })
        }
    }
})


async function init(to, from, next) {
    // console.log('去向', to)
    // console.log('来源', from)
    if (to.meta.type == 2 && from.path != '/') {
        localStorage.setItem('backPath', from.path)
    }
    // 缓存页只有前往下级页面返回时缓存，同级切换时不缓存2023.4.7
    if (to.meta.type == 1 && from.meta.type == 2) {
        to.meta.keepAlive = to.meta.isAlive == 1 ? true : false;
    } else {
        to.meta.keepAlive = false;
    }
    if (to.query.flag) localStorage.setItem('menuFlag', to.query.flag)
    if (store.state.auth.menuList.length === 0) {
        let roleId = localStorage.getItem('roleId');
        let category = JSON.parse(localStorage.getItem("userInfo")).category || "";
        let flag = localStorage.getItem('menuFlag') || '';
        // console.log(flag)
        let loading;
        if (from.path == "/login") {
            loading = Loading.service({ target: '#login_box' });
        } else {
            loading = Loading.service({ fullscreen: true });
        }
        // 获取菜单、路由、字典等数据
        var p1 = store.dispatch("dic/getCollegeOptions");
        // var p2 = store.dispatch("dic/getObsConfig");
        var p4 = store.dispatch("dic/getDicList", ["nation", 'political', 'studentStatus', 'familyBackground', 'healthCondition', 'academicDegree', 'academicYear', 'currentYear', 'menuFlag']);
        var p20 = store.dispatch("auth/initMenu", { roleId, flag: category == 'student' ? flag : '' });

        Promise.all([p1, p4, p20]).then(values => {
            let routes = store.state.auth.routes;
            if (routes && routes.length == 0) {
                localStorage.clear();
                next({
                    path: "/error/401",
                });
            } else {
                routes.forEach(route => {
                    router.addRoute(
                        'management',
                        route,
                    )
                })
                // debugger;
                let isPermission = store.state.auth.permissionList.some(item => {
                    if (item.url.includes(':')) {
                        return to.fullPath.includes(item.url.split(':')[0]);
                    } else {
                        return item.url == to.fullPath.split("?")[0];
                    }
                });
                if (isPermission) {
                    loading.close();
                    return next({ path: to.path })
                } else {
                    // 如果页面刷新或要前往登录页，则跳转到路由的第一个页面，否则401
                    if (from.path == "/" || from.path == "/login" || to.path == "/" || to.path == "/login" || to.path == "/home") {
                        loading.close();
                        return next({
                            path: routes[0].path,
                            replace: true
                        })
                    } else {
                        loading.close();
                        next({
                            path: "/error/401",
                        });
                    }
                }

            }
            loading.close();
        }, reason => {
            loading.close();
        });
    } else {
        // 如果存在菜单，则直接进行跳转判断
        let isPermission = store.state.auth.permissionList.some(item => {
            if (item.url.includes(':')) {
                return to.fullPath.includes(item.url.split(':')[0]);
            } else {
                return item.url == to.fullPath.split("?")[0];
            }
        });
        if (isPermission) {
            next()
        } else {
            // 如果页面刷新或要前往登录页，则跳转到路由的第一个页面，否则401
            // from.path == "/" || from.path == "/login" ||
            if (to.path == "/" || to.path == "/login" || to.path == "/home") {
                return next({
                    path: store.state.auth.routes[0].path,
                    replace: true
                })
            } else {
                next({
                    path: "/error/401",
                });
            }

        }
    }
}

export default router;
